import { api } from '../configs/axiosConfigs';

export const createAvmResults = async(property_id: string) => {
  return await api.post(`/properties/${property_id}/avm_results`, { property_id });
};
